<template>
    <div class="row aditionalItem">
        <div class="col-9">
            <div class="title">
                {{ aditional.title }}
            </div>
        </div>
        <div class="col-3">
            <div class="value">
                {{ aditional.quantity }}x {{ formatedValue }}
            </div>
        </div>
    </div>
</template>

<script>

export default {
    components: {  },
    props: {
        aditional: {
            type: Object,
            required: true,
        },
    },
    data(){
        return {
        };
    },
    computed: {
        formatedValue() {
            return this.aditional.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        }
    },
    methods: {
    },
    mounted() {
    }
}
</script>

<style scoped lang="scss">
.aditionalItem {
    
    .title {

    }

    .value {
        text-align: right;

    }
}
</style>
